import React from "react"
import "./frames.css"

const MedidasSeguridad = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Medidas Seguridad</h1>
      <h2 className="frames-subtitle">
        Medidas de Seguridad en la Instalación
      </h2>
      <p className="frames-text">
        La seguridad en las instalaciones de Medicina Hiperbárica es esencial.
        Estas medidas son definidas tanto por la normativa local como por los
        propios fabricantes y distribuidores como OXANA. Estas normas garantizan
        el correcto funcionamiento y seguridad en el tratamiento. OXANA te
        orientará en estas importantes medidas para obtener la licencia de
        actividad y, sobre todo, para garantizar tratamientos seguros.
      </p>
    </div>
  )
}

export default MedidasSeguridad
